// copied from app/assets/modules/react-shared/Notifications/mutations/mark-notification-as-read-mutation.ts
// since this is not moved into a ui package yet

import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import mutationRequest, {
  type markNotificationAsReadIssueViewerMutation,
} from './__generated__/markNotificationAsReadIssueViewerMutation.graphql'

type MarkNotificationAsReadMutationProps = {
  environment: Environment
  notificationId: string
  onError?: (error: Error) => void
  onCompleted?: () => void
}

graphql`
  mutation markNotificationAsReadIssueViewerMutation($input: MarkNotificationAsReadInput!) @raw_response_type {
    markNotificationAsRead(input: $input) {
      success
      notificationThread {
        id
        isUnread
      }
    }
  }
`

export function markNotificationAsReadIssueViewerMutation({
  environment,
  notificationId,
  onError,
  onCompleted,
}: MarkNotificationAsReadMutationProps) {
  return commitMutation<markNotificationAsReadIssueViewerMutation>(environment, {
    mutation: mutationRequest,
    variables: {input: {id: notificationId}},
    optimisticResponse: {
      markNotificationAsRead: {
        success: true,
        notificationThread: {
          id: notificationId,
          isUnread: false,
        },
      },
    },
    onError,
    onCompleted: () => onCompleted && onCompleted(),
  })
}
